import React, { useState,useEffect } from 'react';
import { Container, Grid, Card, CardMedia, CardContent, Typography, Button, Select, MenuItem, IconButton,  CardActionArea } from '@mui/material';
import { Link } from 'react-router-dom';
import axiosInstance from '../common/axios';
import AddToCartButton from '../components/AddToCartButton';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {fetchSupplierProducts}  from '../service/filterService';
import { styled } from '@mui/material/styles';
import { useAuth } from '../context/AuthContext';
import { requestProductApproval, approveProduct } from '../service/supplierService';


const SelectableCard = styled(Card)(({ theme, isSelected }) => ({
  transition: 'transform 0.2s, box-shadow 0.2s, border-color 0.2s',
  border: '2px solid transparent',
  '&:hover': {
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    transform: 'translateY(-2px)',
  },
  ...(isSelected && {
    borderColor: theme.palette.primary.main,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
  }),
}));


const ProductContainer = ({supplierId, selectedProducts, productList, action}) => {
    
    var [products, setProducts] = useState(null);
  var [product, setProduct] = useState(null);
    const [selectedVariants, setSelectedVariants] = useState({});
 const [currentImageIndex, setCurrentImageIndex] = useState({});

   const [selectedProductIds, setSelectedProductIds] = useState([]);

 // const [filteredProducts, setFilteredProducts] = useState([]);

  async function fetchFilteredAllActiveProducts(){

           const res = await fetchSupplierProducts(null, {active: true, approval: false} );
   //  setFilteredProducts(res.data);
  
    setProducts(res.data);
  }
  
  
  async function fetchFilteredAllInActiveProducts(){

           const res = await fetchSupplierProducts(null, {active: false, approval: false} );
   //  setFilteredProducts(res.data);

    setProducts(res.data);
  }
    
      async function fetchFilteredAllSupplierProducts(){
           const res = await fetchSupplierProducts(supplierId, {active: false, approval: false} );
     //setFilteredProducts(res.data);
      
    setProducts(res.data);
      }
    

  useEffect(() => { 
      
      console.log("nn "+ supplierId);
    if(supplierId){
          fetchFilteredAllSupplierProducts();
      }else{
        
        if(action === "verify"){
          fetchFilteredAllInActiveProducts();
        }else{
          fetchFilteredAllActiveProducts();
        }
          
      }
      if(productList){
          setProducts(productList);
      }
      
         if(selectedProducts){
            selectedProducts(selectedProductIds);
        }

  }, [supplierId,productList,selectedProducts]);
  
 

  // A helper function to manage the selection logic
  const handleProductSelect = (productId) => {
    // Check if the product is already selected
    if (selectedProductIds.includes(productId)) {
      // If it is, filter it out (un-select)
      setSelectedProductIds(selectedProductIds.filter(id => id !== productId));
        
        if(selectedProducts){
            selectedProducts(selectedProductIds.filter(id => id !== productId));
        }
        
    } else {
      // If it's not, add it to the list (select)
      
      if(supplierId || action === "verify" ){
             setSelectedProductIds([...selectedProductIds, productId]);
        
         if(selectedProducts){
            selectedProducts([...selectedProductIds, productId]);
        }
      } else {
        
           const product = products.find(p => p.productId === productId);
        
        const hasMissingWareId = !product.variants || 
    product.variants.some(v => v.warehouseId === null || v.warehouseId === undefined);
        
        if(hasMissingWareId){
          alert("Add the product variant to the inventory");
        }

            // 2. Check if the product exists and if commonvalue equals "Test"
            if (product && product.commiStatus === "Pricing AVailable") {

               setSelectedProductIds([...selectedProductIds, productId]);

                   if(selectedProducts){
                      selectedProducts([...selectedProductIds, productId]);
                  }

                 } else {
                   alert("Product not added. Pricing not available");
                 }
          
        }
        
      } 

      
  };


  // Function to get the price, considering variant adjustments
  const getProductPrice = (product, variant) => {
    // If a variant is selected and has a price adjustment, apply it.

    if (variant && variant.price !== undefined) {
      return variant.price;
    }
    // Otherwise, return the base product price.
    return product.salesPrice;
  };
  
  const getApplicableDiscount = (product, variant) => {
    // Get the base price of the product, including any variant adjustment
    const basePrice = getProductPrice(product, variant);
    let discount = null;

    // First, check for a discount on the variant
    if (variant && variant.discount) {
      discount = variant.discount;
    } 
    // If no variant discount, check for a shared discount on the product
    else if (product.sharedDiscount) {
      discount = product.sharedDiscount;
    }
    
    // Calculate the discount amount based on the determined discount
    if (discount) {
      if (discount.type === 'PERCENTAGE') {
        return {
          type: 'PERCENTAGE',
          amount: basePrice * discount.percentage,
          percent: discount.percentage
        };
      } else if (discount.type === 'FIXED_AMOUNT') {
        return {
          type: 'FIXED_AMOUNT',
          amount: discount.amount,
           percent: 0
        };
      }
    }
    
    // Return a default object if no discount applies
    return {
      type: null,
      amount: 0,
       percent: 0
    };
  };
  
  
  
  
    
  const getApplicableInventory = (product, variant) => {
    
     if (variant && variant.warehouseId !== undefined && !variant.warehouseId) {
      return "Not available to inventory";
    } else{
      return "Available ";
    }
    
  };

  // Function to handle variant selection change
  const handleVariantChange = (product, variant) => {
    setSelectedVariants(prevState => ({
      ...prevState,
      [product.productId]: variant,
    }));
    // When a variant is selected, reset the image to the variant's image
    // Find the index of the selected variant's image within the full image list
    const allImages = [product.imageUrl, ...product.variants.map(v => v.imageUrl)];
    const newIndex = allImages.findIndex(img => img === variant.imageUrl);
    setCurrentImageIndex(prevState => ({
      ...prevState,
      [product.productId]: newIndex !== -1 ? newIndex : 0,
    }));
  };

  // Function to handle image navigation
  const handleImageNav = (productId, direction, imageCount) => {
    setCurrentImageIndex(prevState => {
      const currentIndex = prevState[productId] !== undefined ? prevState[productId] : 0;
      let newIndex;
      if (direction === 'next') {
        newIndex = (currentIndex + 1) % imageCount;
      } else {
        newIndex = (currentIndex - 1 + imageCount) % imageCount;
      }
      return { ...prevState, [productId]: newIndex };
    });
  };
  
  const DEFAULT_IMAGE = "/images/no_image.png";
const handleImageError = (e) => {
    // Prevents infinite loop if the dummy image itself is missing
    e.target.onerror = null; 
    e.target.src = DEFAULT_IMAGE;
  };
   
  return (
    <Container style={{ paddingBottom: '20px', paddingTop: '20px' }}>
      <Typography variant="h4" gutterBottom>
       Products
      </Typography>
          <Grid container spacing={4}>
      {Array.isArray(products) && products.length > 0 ? (
    
        products.map((product) => {
        const currentVariant = selectedVariants[product.productId] ?? product.variants[0];
          // Determine the final price to display
          const displayPrice = getProductPrice(product, currentVariant);
          const discountDetails = getApplicableDiscount(product, currentVariant);
           const inventoryDetails = getApplicableInventory(product, currentVariant);
          // Create a single array of all possible images for the slider
          const allImages = [product.imageUrl, ...product.variants.map(v => v.imageUrl)].filter(Boolean);
          const currentImage = allImages[currentImageIndex[product.productId] || 0];
          const isSelected = selectedProductIds.includes(product.productId);
          
          return (
          <Grid item key={product.productId} xs={12} sm={6} md={4}>
               
                  <SelectableCard isSelected={isSelected}>
                  {/* CardActionArea makes the entire card clickable */}
                  <CardActionArea style={{ position: 'relative' }} onClick={() => handleProductSelect(product.productId)}>
                <CardMedia
                  component="img"
                  alt={product.productName}
                  style={{ objectFit: 'contain' }}
                  height="240"
                  image={`../images/${currentImage}`}
                   onError={handleImageError}
                />
                {allImages.length > 1 && (
                  <>
                    <IconButton
                      onClick={() => handleImageNav(product.productId, 'prev', allImages.length)}
                      style={{ position: 'absolute', left: 5, top: '50%', transform: 'translateY(-50%)', backgroundColor: 'rgba(255, 255, 255, 0.7)', padding: '4px' }}
                      size="small"
                    >
                      <ArrowBackIosIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      onClick={() => handleImageNav(product.productId, 'next', allImages.length)}
                      style={{ position: 'absolute', right: 5, top: '50%', transform: 'translateY(-50%)', backgroundColor: 'rgba(255, 255, 255, 0.7)', padding: '4px' }}
                      size="small"
                    >
                      <ArrowForwardIosIcon fontSize="small" />
                    </IconButton>
                  </>
                )}
              <CardContent>
                <Typography gutterBottom variant="h6">
                  {product.productName} - {product.commiStatus} - {inventoryDetails}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {product.description}
                </Typography>
                <Typography variant="subtitle1" color="primary">
                  ₹{displayPrice} 
                   {discountDetails.amount > 0 && (
                      <span style={{ marginLeft: '8px', color: 'green' }}>
                        {discountDetails.type === 'PERCENTAGE' ? `(${discountDetails.percent}% OFF, saving ₹${discountDetails.amount.toFixed(2)})` : `(Saving ₹${discountDetails.amount.toFixed(2)})`}
                      </span>
                    )}
                </Typography>
                  <Select
                    value={currentVariant?.variantId || product.variants[0]?.variantId || ''}
                    onChange={(e) => {
                      const variantId = e.target.value;
                      const variant = product.variants.find(v => v.variantId === variantId);
                      handleVariantChange(product, variant);
                    }}
                    style={{ marginTop: '5px' }}
                  >
                    {product.variants.map((variant) => (
                      <MenuItem key={variant.variantId} value={variant.variantId}>
                        {variant.variantName} - {variant.color} {variant.size && `(${variant.size})`}
                      </MenuItem>
                    ))}
                  </Select>
              </CardContent>
                        </CardActionArea>
                </SelectableCard>
          </Grid>
          );
        })
       ) : (
        <Typography variant="body1" color="textSecondary">
          No products available
        </Typography>
      )}
     </Grid>
   
    </Container>
  );
};

export default ProductContainer;
